import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { Headline, createHeadline } from '@vfde-brix/ws10/headline';
import { JarvisProduct } from '@vfde-sails/avc-core';
import { getAvcResultSecondAlternativeText } from '../container/AvailabilityCheck/util/result';

export const mountHeadline = (wrapperId: HtmlId) =>
    createComponentById(createHeadline, wrapperId, NO_PATTERN_BUSINESS_LOGIC);

export const updateUpsellResultText = (
    comp: Headline | null,
    upsellTariff?: JarvisProduct,
) => {
    if (!comp) {
        return;
    }

    comp.update({
        stdContent: getAvcResultSecondAlternativeText(upsellTariff),
    });
};
